import { useForm, UseFormReturn } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { LockUserPayload } from 'services/requests';

export enum StatusUserFieldNames {
  comment = 'comment',
}

export const useStatusUserLockModalForm = (): UseFormReturn<LockUserPayload> => {
  const schema: yup.SchemaOf<LockUserPayload> = yup.object({
    comment: yup.string().required(''),
  });

  const form = useForm<LockUserPayload>({
    mode: 'all',
    reValidateMode: 'onChange',
    resolver: yupResolver(schema),
  });

  return form;
};
